module.exports = __webpack_public_path__ + "static/img/img-4.13652570.png";